import { Injectable } from '@angular/core';
import { IButton } from './abcButton/abcButton';
import { IDashBoard } from './abcDashBoard/abcDashBoard';
import { IDrawer } from './abcDrawer/abcDrawer';
import { IInput } from './abcInput/abcInput';
import { ISwitch } from './abcSwitch/abcSwitch';
import { IToolBar } from './abcToolbar/abcToolbar';
import { IRibbon } from './abcRibbon/abcRibbon';
import { IDropDown } from './abcDropDown/abcDropDown';
import { ITextArea } from './abcTextArea/abcTextArea';
import { ICombobox } from './abcCombobox/abcCbxGrid';
import { IGrid } from './abcGrid/abcGrid';
import { ICheckBox } from './abcCheckBox/abcCheckBox';
import { IWindow } from './abcWindow/abcWindow';
import { IContextMenu } from './abcContextMenu/abcContextMenu';
import { ICard } from './abcCard/abcCard';
import { ILoader } from './abcLoader/abcLoader';
import { IPopover } from './abcPopover/abcPopover';
import { IListBox } from './abcListBox/abcListBox';
import { IFileUploader } from './abcFileUploader/abcFileUploader';
import { IScheduler } from './abcScheduler/abcScheduler';
import { ITagBox } from './abcTagBox/abcTagBox';
import { IGallery } from './abcGallery/abcGallery';
import { IButtonGroup } from './abcButtonGroup/abcButtonGroup';
import { IForm } from './abcForm/abcForm';
import { AbcComponentService } from './abcComponent.service';
import { AbcContextMenuComponent } from './abcContextMenu/abcContextMenu.component';
import { AbcListBoxComponent } from './abcListBox/abcListBox.component';
import { IRangeSelector } from './abcRangeSelector/abcRangeSelector';

export type IComponentOptions =
  | IInput
  | IButton
  | IRibbon
  | IDropDown
  | ITextArea
  | ICombobox
  | ITextArea
  | IGrid
  | ICheckBox
  | IWindow
  | IContextMenu
  | ICard
  | ILoader
  | IPopover
  | IListBox
  | IFileUploader
  | IScheduler
  | ITagBox
  | IGallery
  | IDashBoard
  | ISwitch
  | IDrawer
  | IToolBar
  | IButtonGroup
  | IForm
  | IRangeSelector;

export interface AbcComponentType<T> {
  htmlAttributes?: IComponentOptions;
}

@Injectable()
export class AbcContainerService {
  constructor(private abcComponentService: AbcComponentService) {}

  /**
   * Create ABC Component
   * @param ViewContainerRef: Represents a container where the view can be attached to the component.
   * @param component: The component you want to create.
   * @param options: (Optional) such as attributes, style, custom attributes.
   * @returns Instance of the created component.
   */
  createComponent<T>(ViewContainerRef, component: T, options?: IComponentOptions) {
    const loadedComponent = this.abcComponentService.loadComponent(component, ViewContainerRef);
    const containerRefInstance = <AbcComponentType<T>>loadedComponent.componentRef.instance;
    if (containerRefInstance instanceof AbcContextMenuComponent) {
      const abcContextMenu = <AbcContextMenuComponent>containerRefInstance;
      abcContextMenu.source = <IContextMenu>options;
    } else if (containerRefInstance instanceof AbcListBoxComponent) {
      const abcListBox = <AbcListBoxComponent>containerRefInstance;
      abcListBox.source = <IListBox>options;
    } else {
      containerRefInstance.htmlAttributes = options;
    }
    return loadedComponent;
  }
}
